import { Routes } from '@angular/router';
import { BooksHomeComponent } from './components/books-home/books-home.component';
import { BookComponent } from './components/book/book.component';


export const routes: Routes = [
  { path: 'books', component: BooksHomeComponent, title: 'Books List', },
  { path: 'books/:asin', component: BookComponent, title: 'Book Details', },
  { path: '', redirectTo: '/books', pathMatch: 'full', },
  { path: '**', component: BooksHomeComponent,}
];
